module.exports = __webpack_public_path__ + "static/media/image-placeholder.f652634b.png";